import { render, staticRenderFns } from "./GridPivotTableComponent.vue?vue&type=template&id=f89145c4&lang=pug"
import script from "./GridPivotTableComponent.vue?vue&type=script&lang=ts"
export * from "./GridPivotTableComponent.vue?vue&type=script&lang=ts"
import style0 from "./GridPivotTableComponent.vue?vue&type=style&index=0&id=f89145c4&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f89145c4')) {
      api.createRecord('f89145c4', component.options)
    } else {
      api.reload('f89145c4', component.options)
    }
    module.hot.accept("./GridPivotTableComponent.vue?vue&type=template&id=f89145c4&lang=pug", function () {
      api.rerender('f89145c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GridPivotTable/GridPivotTableComponent.vue"
export default component.exports